import React from "react";
import styled from "styled-components";
import CenteredWrapper from './CenteredWrapper';
import { breakpoints } from './constants';

const Testimonials = styled.div`
  display: flex;
  width: 100%;
  max-width: 1080px;
  flex-flow: column;
  @media (min-width: ${breakpoints.desktop}) {
    flex-flow: row;
  }
`;

export default Testimonials;



// WEBPACK FOOTER //
// ./src/styled-components/Testimonials.js